import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import P2 from '@base/P2/P2';
import Avatar from '@base/Avatar/Avatar';
import Divider from '@base/Divider/Divider';
import ArrowBack from '@icon/ArrowBack';
import { dateWithTime } from '@utils/dates';
import CardHeader from './CardHeader';
import Card from './Card';

const CardWrapper = styled.div``;

const Title = styled(P2)`
  color: var(--color-text-primary);
`;

const StyledCard = styled(Card)`
  margin-top: 16px;
`;

const CardInfo = styled.div`
  display: flex;
`;

const SubTitle = styled.span`
  font-size: 12px;
  line-height: 150%;
  color: var(--color-text-secondary);
  margin-top: 4px;
`;

const UNDivider = styled(Divider)`
  margin: 16px 0;
`;

const Time = styled.span`
  font-size: 16px;
  line-height: 150%;
  color: var(--color-text-primary);
  margin-left: 8px;
`;

const SlashedTime = styled(Time)`
  text-decoration: line-through;
  color: var(--color-text-secondary);
  font-weight: 600;
  margin-right: 8px;
`;

const Arrow = styled(ArrowBack)`
  transform: rotate(180deg);
`;

const WrappedDiv = styled.div`
  margin-left: 16px;
`;

const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ClassRescheduledCard = ({ story, batch }) => {
  const { message, created_at, object } = story;

  if (!object.value) return null;
  const lesson = `Lesson ${object?.rank}`;

  const avatar = object.value.author.avatar_v1 || object.value.author.avatar;
  return (
    <CardWrapper>
      <CardHeader
        message={message}
        img="rescheduledclass.svg"
        created_at={created_at}
        subtitle={batch && object.value?.collection?.name}
      />
      <StyledCard>
        <CardInfo>
          <Avatar src={avatar} size="48px" />
          <WrappedDiv>
            <Title>{object.value.title}</Title>
            <SubTitle>{lesson}</SubTitle>
          </WrappedDiv>
        </CardInfo>
        <UNDivider />
        <ArrowWrapper>
          <SlashedTime>{dateWithTime(object.value.old_time)}</SlashedTime>
          <Arrow size="24px" color="var(--color-text-primary)" />
          <Time>{dateWithTime(object.value.new_time)}</Time>
        </ArrowWrapper>
      </StyledCard>
    </CardWrapper>
  );
};

export default ClassRescheduledCard;

ClassRescheduledCard.propTypes = {
  story: PropTypes.objectOf(PropTypes.any).isRequired,
  batch: PropTypes.bool
};

ClassRescheduledCard.defaultProps = {
  batch: false
};
